<div class=" "> 
  <vertical-nav-client [menuItems]="appS.topMenu" [showMenu]="false" [fullScreen]="true" [title]="title" [showSearch]="true"
    [createButton]="true" [findButton]="true">
    <router-outlet></router-outlet>
  </vertical-nav-client>
</div>
